export default __webpack_public_path__ + "static/media/ShriSanjiv.394b505c.jpg";